'use client';

import { useLanguageSync } from '@/hooks/useLanguageSync';
import { useNotificationRefresh } from '@/hooks/useNotificationRefresh';
import { useSessionValidation } from '@/hooks/useSessionValidation';

export function SessionValidator() {
  useSessionValidation();
  useLanguageSync();
  useNotificationRefresh();
  return null;
}
